<!-- Container if Registration -->
<ng-container *ngIf="checkRegistration()">
  <div class="flex-grow-1 w-full h-auto">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<!-- Sidebar and Header for Non-LMS -->
<ng-container *ngIf="checkCurrentRouteIfNotLMS() && !checkRegistration()">
  <div class="flex flex-row h-screen">
    <!-- Sidebar -->
    <div class="main-side-nav flex-shrink-0 h-auto overflow-y-auto" [style.width]="isSideNavMaximize ? '200px' : '92px'" [style.transition]="'width 0.2s ease-in-out'">
      <div class="flex-column pt-5 align-content-center">
        <!-- Logo and Minimize/Maximize Button -->
        <div *ngIf="isSideNavMaximize" class="w-10 flex flex-row mb-6 mx-4 justify-content-center align-items-center">
          <a [routerLink]="['/']"><img src="../assets/Financia-white2.svg" id="financia-logo" class="flex w-11 justify-content-center"></a>
          <div class="toggle-maximize-button border-circle mx-2 h-full px-1 border-1 cursor-pointer" (click)="isSideNavMaximize = !isSideNavMaximize">
            <i class="pi pi-angle-left text-xs font-light text-white"></i>
          </div>
        </div>
        <div *ngIf="!isSideNavMaximize" class="w-10 flex flex-column mb-3 mx-2 justify-content-center align-items-center">
          <a [routerLink]="['/']"><img src="../assets/Financia-white2.svg" id="financia-logo" class="flex w-11 justify-content-center mb-2"></a>
          <div  class="toggle-maximize-button border-circle h-full px-1 border-1 cursor-pointer mt-3" (click)="isSideNavMaximize = !isSideNavMaximize">
            <i class="pi pi-angle-right text-xs font-light text-white"></i>
          </div>
        </div>
  
        <!-- Routes and Pages -->
        <ng-container *ngFor="let item of items">
            <div
              *ngIf="item.visible"
              class="flex flex-column justify-content-center {{isCurrentNavItem(item.title) || isCurrentRoute(item.routerLink[0]) ? '' : 'my-3'}}">
              <div  *ngIf="isSideNavMaximize" >
                <div class="w-full flex p-2 justify-content-center">
                  <div [class]="(item.title === 'dashboard' ? isCurrentRoute(item.routerLink[0]) : isCurrentNavItem(item.title)) ?
                     'selected-container flex w-11 align-items-center border-round-xl py-3 px-3 text-white justify-content-between'
                     : 'hover-container flex w-11 align-items-center justify-content-between'">
    
                    <div class="flex flex-row cursor-pointer w-11" 
                      (click)=" item.routerLink[0] != 'member/lms/home' && item.routerLink[0] != 'admin/lms/home'  ? navigateToLink(item.routerLink[0], item.title) : openWindow(item.routerLink)">
                      <div class="icon-container flex align-items-center justify-content-center {{isCurrentNavItem(item.title) ? 'mr-3' : 'mr-4'}} w-1">
                        <i [class]="item.icon + ' font-light text-xl text-white'"></i>
                      </div>
      
                      <p class="font-bold text-sm text-white">{{item.label}}</p>
                    </div>
                    
                    <i *ngIf="item.expanded != null"
                      class="{{item.expanded === true ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'}} {{isCurrentNavItem(item.title) ? 'ml-1' : 'mr-2'}} font-light text-xl text-white cursor-pointer" 
                      (click)="item.expanded = !item.expanded"></i>
                  </div>
                </div>
                
                <!-- Sub Items -->
                <div *ngIf="item.expanded != null && item.expanded === true">
                  <div class="flex flex-column" *ngFor="let cItem of item.items">
                    <div class="w-full flex p-2 justify-content-center ml-4" *ngIf="cItem.visible && isSideNavMaximize" >
                      <div class="hover-container flex w-11 align-items-center justify-content-between">
                        <div class="flex flex-row cursor-pointer" 
                          (click)=" cItem.routerLink[0] != 'member/lms/home' && cItem.routerLink[0] != 'admin/lms/home' ? navigateToLink(cItem.routerLink[0], cItem.title) : openWindow(cItem.routerLink)">
                          <p class="{{isCurrentRoute(cItem.routerLink[0]) ? 'underline ' : ''}} font-light text-xs text-white">{{cItem.label}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-full flex p-2 justify-content-center" *ngIf="!isSideNavMaximize">
                <div [class]="isCurrentNavItem(item.title) || isCurrentRoute(item.routerLink[0]) ?
                   'selected-container flex align-items-center border-round-xl py-2 px-2 text-white justify-content-center cursor-pointer' 
                   : 'flex align-items-center justify-content-center cursor-pointer'" 
                   (click)=" item.routerLink[0] != 'member/lms/home' && item.routerLink[0] != 'admin/lms/home'  ? navigateToLink(item.routerLink[0], item.title) : openWindow(item.routerLink)">
  
                  <div class="icon-container flex align-items-center justify-content-center">
                    <i [class]="item.icon + ' flex font-light text-xl text-white justify-content-center align-items-center'" style="width: 32px; height: 32px;"></i>
                  </div>
                </div>
              </div>
              
            </div>
        </ng-container>
      </div>
    </div>

    <!-- Header -->
    <div class="flex flex-column w-full h-auto">
      <div class="main-header w-full h-7rem pb-3 ">
        <div class="flex flex-row justify-content-between mt-4 mr-4">
  
          <!-- Greeting -->
          <div class="flex-column w-4 align-content-center ml-5">
            <p class="font-bold text-xl text-white">Hello User 👋</p>
            <p class="text-gray-600 font-light text-xs mt-2 text-white">{{getGreeting()}}</p>
          </div>
  
          <!-- Search Bar -->
          <div class="flex flex-grow w-3 align-items-center justify-content-end xl:w-5">
            <div class="relative w-full justify-content-end h-full align-content-center">
              <input
                type="text"
                pInputText
                placeholder="Search"
                class="text-sm border-round-xl border-2 border-gray-200 p-2 pl-3 pr-6 w-full"
                style="height: 75%;"
              />
              <i class="pi pi-search absolute -ml-5 font-bold text-gray-900 h-full text-gray-400 -mt-2 align-content-center"></i>
            </div>
          </div>
  
          <!-- User Buttons -->
          <div class="user-container border-round-xl flex flex-row align-items-center justify-content-between w-4 mx-4 h-full xl:w-2">
            <div class="flex flex-row align-items-center">
              <!-- Profile -->
              <div class="h-full border-gray-200 border-2 border-round-xl flex align-items-center justify-content-center mr-1 ml-2 p-3 my-1">
                <i class="pi pi-user text-sm text-white"></i>
              </div>
              <!-- Name -->
              <div class="flex flex-column my-1 mx-2">
                <p class="text-white text-sm font-bold">{{appUser?.firstName + " " + appUser?.lastName | titlecase}}</p>
                <p class="text-white text-xs mt-1 font-light">Test Role</p>
              </div>
            </div>

            <!-- Dropdown -->
            <div class="h-full flex align-items-center justify-content-center -mr-1 ml-2 p-3 my-1 cursor-pointer" (click)="LogOut()">
              <i class="pi pi-sign-out text-sm text-white"></i>
            </div>
          </div>
          
        </div>
      </div>
      <div class="flex-grow-1 w-full h-full overflow-y-auto">
          <router-outlet></router-outlet>
      </div>
    </div>
  </div>

</ng-container>

<!-- Sidebar and Header for LMS -->
<ng-container *ngIf="!checkCurrentRouteIfNotLMS() && !checkRegistration()">
  <div class="flex h-screen">
    <!-- Sidebar -->
    <div class="lms-side-nav flex-shrink-0 " [style.width]="isSideNavMaximize ? '13vw' : '5vw'" [style.transition]="'width 0.2s ease-in-out'">
      <div class="flex-column pt-5 align-content-center">
        <div *ngIf="isSideNavMaximize" class="w-10 flex flex-row mb-6 mx-4 justify-content-center align-items-center">
          <a [routerLink]="['/']"><img src="../assets/timefree_logo.png" id="timefree-logo" class="flex w-11 justify-content-center"></a>
          <div class="toggle-maximize-button border-circle hover:border-blue-300 mx-2 h-full px-1 border-1 cursor-pointer" (click)="isSideNavMaximize = !isSideNavMaximize">
            <i class="pi pi-angle-left text-xs font-light"></i>
          </div>
        </div>
        <div *ngIf="!isSideNavMaximize" class="w-11 flex flex-column mb-3 mx-2 justify-content-center align-items-center">
          <a [routerLink]="['/']"><img src="../assets/timefree_logo.png" id="timefree-logo" class="flex w-11 justify-content-center mb-2"></a>
          <div  class="toggle-maximize-button border-circle hover:border-blue-300 -ml-2 h-full px-1 border-1 cursor-pointer mt-3" (click)="isSideNavMaximize = !isSideNavMaximize">
            <i class="pi pi-angle-right text-xs font-light"></i>
          </div>
        </div>

        <ng-container *ngFor="let item of items">
          <ng-container *ngIf="item.visible" class="relative">
            <div *ngFor="let cItem of item.items">

              <ng-container *ngIf="cItem.visible">
                <div class="flex justify-content-center cursor-pointer {{isCurrentRoute(cItem.routerLink[0]) ? '' : 'my-3'}}" 
                  (click)=" navigateToLink(cItem.routerLink[0], cItem.title)">
                  <div class="w-full flex p-2 justify-content-center" *ngIf="cItem.visible && isSideNavMaximize" >
                    <div [class]="isCurrentRoute(cItem.routerLink[0]) ?
                      'flex w-11 align-items-center border-round-xl py-3 px-3 container-gradient text-white' 
                      : 'flex w-11 ml-4 align-items-center'">

                      <div class="icon-container flex align-items-center justify-content-center mr-4 w-1">
                        <i [class]="cItem.icon + ' font-light text-2xl'"></i>
                      </div>

                      <p class="font-light text-lg">{{cItem.label}}</p>
                    </div>
                  </div>

                  <div class="w-full flex p-2 justify-content-center" *ngIf="cItem.visible && !isSideNavMaximize">
                    <div [class]="isCurrentRoute(cItem.routerLink[0]) ?
                      'flex w-6 align-items-center border-round-xl py-2 px-2 container-gradient text-white justify-content-center' 
                      : 'flex w-11 align-items-center justify-content-center'">

                      <div class="icon-container flex align-items-center justify-content-center">
                        <i [class]="cItem.icon + ' font-light text-2xl'"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="flex flex-column w-full mt-3">
      <div class="w-full h-8rem h-full">
        <div class="flex flex-row justify-content-between mt-4 mx-4">
  
          <!-- Greeting -->
          <div class="flex-column w-4 align-content-center">
            <p class="font-bold text-3xl">Hello User 👋</p>
            <p class="text-gray-600 font-light">Let's learn something new today!</p>
          </div>
  
          <!-- Search Bar -->
          <div class="flex flex-grow w-6 align-items-center justify-content-end">
            <!-- <div class="relative w-full justify-content-end h-full align-content-center">
              <input
                type="text"
                pInputText
                placeholder="Search from courses..."
                class="text-sm border-round-xl border-2 border-gray-200 hover:border-blue-300 p-2 pl-3 pr-6 w-full"
                style="height: 85%;"
              />
              <i class="pi pi-search absolute -ml-5 font-bold text-gray-900 h-full text-gray-400 -mt-1 align-content-center"></i>
            </div> -->
          </div>
  
          <!-- User Buttons -->
          <div class="flex flex-row align-items-center justify-content-center w-1 mx-4 h-full">
            <div class="h-full border-gray-200 hover:border-blue-300 border-2 border-round-xl flex align-items-center justify-content-center mr-3 ml-2 p-3 transition-duration-400 cursor-pointer">
              <i class="pi pi-bell text-xl"></i>
            </div>
            <div class="h-full border-gray-200 hover:border-blue-300 border-2 border-circle flex align-items-center justify-content-center ml-3 mr-2 p-3 transition-duration-400 cursor-pointer" (click)="openProfile()">
              <i class="pi pi-user text-2xl"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full h-full overflow-y-auto">
        <ng-container *ngIf="!checkCurrentRouteIfNotLMS()">
          <router-outlet></router-outlet>
        </ng-container>
      </div>
    </div>

  </div>
</ng-container>

<ngx-ui-loader></ngx-ui-loader>

<p-confirmDialog key="500Dialog" appendTo="body" [baseZIndex]="900000">
  <ng-template pTemplate="header">
    <div class="flex justify-content-between">
      <div class="text-lg font-semibold">Sorry!</div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-toast styleClass="w-11 md:w-auto"></p-toast>
